import React from "react";

import { Helpers } from "../../config/Helpers"
import {ReactSession} from "react-client-session";
import {decode as base64_decode} from "base-64";
import queryString from "query-string";

class OrderStatusDetails extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            urlParam: queryString.parse(window.location.search),
            kodeTransaksiOrder: '',
            courierList: ['Biteship','Lalamove'],
            tracking: '',
            data: [],
            loading: true,
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + encodeURIComponent(window.location.href);
        }else{
            const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';

            this.setState({
                kodeTransaksiOrder: kodeOrder
            }, () => {
                this.getOrderDetails();
            });
        }
    }

    getOrderDetails = () => {
        Helpers.getListOrder('no', this.state.kodeTransaksiOrder, '', '', '').then(res => {
            if(res && res.length > 0){
                const obj = res[0];

                if(this.state.courierList.includes(obj.TipePengiriman) && obj.biteship_tracking){
                    this.setState({ loading: false, tracking: obj.biteship_tracking });
                }else{
                    this.getOrderChronology();
                }
            }else{
                this.setState({ loading: false });
            }
        });
    };

    getOrderChronology = () => {
        Helpers.GetOrderChronology(this.state.kodeTransaksiOrder).then(res => {
            this.setState({
                data: (res) ? res : [],
                loading: false,
                tracking: ''
            });
        });
    };

    formatDate = (jam, waktu) => {
        if(!jam || jam === '-'){
            return '-';
        }

        return jam + ' ' + (waktu || '');
    };

    render() {
        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="javascript:void(0);" onClick={() => {window.history.back()}} className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Detail Status</h1>
                    </div>

                    <div className="detail-wrap">
                        {
                            this.state.loading ? (
                                <div className="detail-card">
                                    <div className="detail-card-head">
                                        <span className="detail-card-accent"></span>
                                        <span className="detail-card-title">Memuat data...</span>
                                    </div>
                                </div>
                            ) : this.state.tracking ? (
                                <div className="detail-card" style={{padding: 0, overflow: 'hidden'}}>
                                    <iframe src={this.state.tracking} title="Tracking" width="100%" height="500" style={{border: 'none', display: 'block'}}></iframe>
                                </div>
                            ) : this.state.data.length > 0 ? (
                                <div className="detail-card">
                                    <div className="detail-card-head">
                                        <span className="detail-card-accent"></span>
                                        <span className="detail-card-title">Status Perjalanan Pesanan</span>
                                    </div>

                                    <div className="timeline-wrap">
                                        {
                                            this.state.data.map((object, i) => {
                                                const done = !!object.tgl;
                                                const isLast = i === this.state.data.length - 1;

                                                return (
                                                    <div className="timeline-item" key={i}>
                                                        <div className="timeline-marker">
                                                            <span className={'timeline-dot' + (done ? ' done' : '')}>
                                                                {
                                                                    done && (
                                                                        <i className="fi-rs-check"></i>
                                                                    )
                                                                }
                                                            </span>
                                                            {
                                                                !isLast && (
                                                                    <span className={'timeline-line' + (done ? ' done' : '')}></span>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="timeline-content">
                                                            <div className={'timeline-title' + (done ? ' done' : '')}>{object.note}</div>
                                                            <div className="timeline-date">{this.formatDate(object.jam, object.waktu)}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            ) : (
                                <div className="order-empty">
                                    <i className="fi-rs-receipt"></i>
                                    <p>Status pesanan tidak ditemukan</p>
                                </div>
                            )
                        }
                    </div>
                </main>
            </>
        );
    }
}

export default OrderStatusDetails;
